import AIReadinessAssessment from './AIReadinessAssessment';
import './App.css';

function App() {
  return <AIReadinessAssessment />;
}

export default App;